import React, { Component } from 'react'

import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import moment from 'moment'
import { Form, Input, InputNumber, DatePicker, Spin, Button, Popconfirm } from 'antd'

import * as scheduleRepairSelectors from '../../selectors/scheduleRepair/scheduleRepair'
import { actions as scheduleRepairActions } from '../../redux/modules/jobFunctions/scheduleRepairActions'

const propTypes = {
  jobId: PropTypes.any.isRequired,

  getScheduleRepairSchedules: PropTypes.func.isRequired,
  schedules: PropTypes.array.isRequired,
  loadingSchedules: PropTypes.bool.isRequired,
  addScheduleRepair: PropTypes.func.isRequired,
  updateRepairDates: PropTypes.func.isRequired,
  getSelectedScheduleByIndex: PropTypes.func.isRequired,
  deleteScheduleRepair: PropTypes.func.isRequired
}

const FormItem = Form.Item

class Schedules extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditing: false,
      selectedDevice: 0
    }

    const { getScheduleRepairSchedules, jobId } = this.props
    getScheduleRepairSchedules(jobId)
  }

  handleChangeDevice = index => {
    this.setState({
      selectedDevice: index
    })
  }

  handleAddDevice = () => {
    const { addScheduleRepair, jobId } = this.props
    addScheduleRepair(jobId)
  }

  handleEditDateClick = () => {
    this.setState({
      isEditing: true
    })
  }

  handleCancelEditClick = () => {
    this.setState({
      isEditing: false
    })
  }

  handleSaveDatesClick = () => {
    const form = this.props.form
    const { updateRepairDates, jobId, getSelectedScheduleByIndex } = this.props
    const { selectedDevice } = this.state

    form.validateFields((err, values) => {
      if (err) {
        return
      }

      const selectedSchedule = getSelectedScheduleByIndex(selectedDevice)

      values.jobId = jobId

      updateRepairDates(jobId, selectedSchedule.id, values)

      form.resetFields()
    })
    this.setState({
      isEditing: false
    })
  }

  confirmDelete = () => {
    const { deleteScheduleRepair, jobId, getSelectedScheduleByIndex } = this.props
    const { selectedDevice } = this.state

    const selectedSchedule = getSelectedScheduleByIndex(selectedDevice)

    deleteScheduleRepair(jobId, selectedSchedule.id)

    this.setState({
      selectedDevice: 0
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { schedules, loadingSchedules } = this.props
    const { isEditing, selectedDevice } = this.state

    return (
      <div>
        <div className="jobsBar">
          Maintenance Schedule
          {!isEditing && (
            <div className="jobsBarAdd" onClick={() => this.handleEditDateClick()}>
              <i className="fa fa-pencil-square" aria-hidden="true" />
              &nbsp;<div className="addJobLabel">EDIT Dates</div>
            </div>
          )}
          {isEditing && (
            <div className="displayFlex">
              <div className="jobsBarAdd" onClick={() => this.handleSaveDatesClick()}>
                <i className="fa fa-save" aria-hidden="true" />
                &nbsp;<div className="addJobLabel">SAVE CHANGES</div>
              </div>
              <div className="jobsBarAdd" onClick={() => this.handleCancelEditClick()}>
                <i className="fa fa-ban" aria-hidden="true" />
                &nbsp;<div className="addJobLabel">CANCEL</div>
              </div>
            </div>
          )}
        </div>
        {loadingSchedules && <Spin />}
        {!loadingSchedules &&
          schedules.length > 0 && (
            <React.Fragment>
              <div className="pt-3 pl-3">
                <div className="row">
                  <div className="col marginLeft5">Devices</div>
                </div>
                <div className="row">
                  <div className="col d-flex">
                    {schedules.map((schedule, index) => (
                      <div key={index}>
                        <Button
                          type={index === selectedDevice ? 'primary' : 'default'}
                          className="marginLeft5"
                          onClick={() => this.handleChangeDevice(index)}
                        >
                          {index + 1}
                        </Button>
                      </div>
                    ))}
                    <Button
                      type="default"
                      icon="plus"
                      className="marginLeft10"
                      onClick={() => this.handleAddDevice()}
                    />
                  </div>
                </div>
              </div>
              <Form layout="vertical">
                <div className="row padding20">
                  <div className="col-xs-12 col-md-4">
                    <div className="dateBlock">
                      <div className="jobDetailsHeader">Controller Code</div>
                      {isEditing && (
                        <FormItem>
                          {getFieldDecorator('controller_code', {
                            initialValue: schedules[selectedDevice].controller_code
                          })(<Input />)}
                        </FormItem>
                      )}
                      {!isEditing && (
                        <div>
                          {schedules[selectedDevice].controller_code
                            ? schedules[selectedDevice].controller_code
                            : 'Not Entered'}
                        </div>
                      )}
                    </div>
                    <div className="dateBlock">
                      <div className="jobDetailsHeader">CAT 1 Due</div>
                      {isEditing && (
                        <FormItem>
                          {getFieldDecorator('cat1_due_date', {
                            initialValue: moment(schedules[selectedDevice].cat1_due_date).isValid()
                              ? moment(schedules[selectedDevice].cat1_due_date)
                              : null
                          })(<DatePicker />)}
                        </FormItem>
                      )}
                      {!isEditing && (
                        <div>
                          {schedules[selectedDevice].cat1_due_date !== null
                            ? moment(schedules[selectedDevice].cat1_due_date).format('MM/D/YYYY')
                            : 'Not Entered'}
                        </div>
                      )}
                    </div>
                    <div className="dateBlock">
                      <div className="jobDetailsHeader">CAT 5 Due</div>
                      {isEditing && (
                        <FormItem>
                          {getFieldDecorator('cat5_due_date', {
                            initialValue: moment(schedules[selectedDevice].cat5_due_date).isValid()
                              ? moment(schedules[selectedDevice].cat5_due_date)
                              : null
                          })(<DatePicker />)}
                        </FormItem>
                      )}
                      {!isEditing && (
                        <div>
                          {schedules[selectedDevice].cat5_due_date !== null
                            ? moment(schedules[selectedDevice].cat5_due_date).format('MM/D/YYYY')
                            : 'Not Entered'}
                        </div>
                      )}
                    </div>
                    <div className="dateBlock">
                      <div className="jobDetailsHeader">Targeted Monthly Visit Day</div>
                      {isEditing && (
                        <FormItem>
                          {getFieldDecorator('targeted_monthly_visit_day', {
                            initialValue: schedules[selectedDevice].targeted_monthly_visit_day
                          })(<InputNumber />)}
                        </FormItem>
                      )}
                      {!isEditing && (
                        <div>{schedules[selectedDevice].targeted_monthly_visit_day}</div>
                      )}
                    </div>
                  </div>
                </div>
              </Form>
              <div className="row pl-3">
                <div className="col-md-12">
                  <Popconfirm
                    title="Are you sure you want to delete this schedule?"
                    onConfirm={this.confirmDelete}
                    onCancel={this.cancelDelete}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button className="marginRight20" type="danger" icon="delete" />
                  </Popconfirm>
                </div>
              </div>
            </React.Fragment>
          )}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  schedules: scheduleRepairSelectors.getSchedules(state, props),
  loadingSchedules: scheduleRepairSelectors.getLoadingSchedules(state, props),
  getSelectedScheduleByIndex: scheduleRepairSelectors.getSelectedScheduleByIndex(state, props)
})
const mapDispatchToProps = (dispatch, props) => ({
  getScheduleRepairSchedules: jobId =>
    dispatch(scheduleRepairActions.getScheduleRepairSchedules(jobId)),
  addScheduleRepair: jobId => dispatch(scheduleRepairActions.addScheduleRepair(jobId)),
  updateRepairDates: (jobId, scheduleId, content) =>
    dispatch(scheduleRepairActions.updateRepairDates(jobId, scheduleId, content)),
  deleteScheduleRepair: (jobId, scheduleId) =>
    dispatch(scheduleRepairActions.deleteScheduleRepair(jobId, scheduleId))
})

Schedules.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(Schedules)))



// WEBPACK FOOTER //
// ./src/components/scheduleRepair/Schedules.js